import Loading from "@fuse/components/FuseLoadable/Loading";
import _ from "@lodash";
import { MenuItem, Radio, TextField, withStyles } from "@material-ui/core";
import Constante from "Constante.json";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPTooltip from "app/Core/Components/Tooltip/XAPPTooltip";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import dayjs from "dayjs";
import React from "react";


const styles = theme => ({
    divHorarioItem: {
        width: 15,
        minHeight: 25,
        border: "1px solid #f2f2f2",
    },
    divHorario: {
        "@media all and (display-mode: fullscreen)": {
            width: "100% !important"
        },
        "@media (min-width: 1920px)": {
            width: "100% !important"
        },
    },
    divNomeItem: {
        height: 25,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        //paddingRight: 5
    },
    paper: {
        border: "1px solid " + (theme.palette.type === "dark" ? "#6e6e6e" : "#c4c4c4"),
        //marginBottom: "24px",
        padding: "4px"
    },
    divSelected: {
        border: "2px solid " + theme.palette.primary.main,
    },
    checkboxRoot: {
        color: "#FFF !important",
        "&$checked": {
            color: "#FFF !important",
        },
    },
    checkboxChecked: {},
    contentPreload: {
        position: "relative",
        display: "none",
        overflow: "auto",
        flex: "1 1 auto",
        flexDirection: "column",
        width: "100%",
        "-webkit-overflow-scrolling": "touch",
        zIndex: 2
    }
});

class DataHora extends XAPPComponent {

    state = {
        step: null,
        time: null,
    };

    componentDidMount() {
        const { form } = this.props;
        let AData = new Date().getTime();
        let AStepAgendamento = this.getStepAgendamento();
        if (!_.isNull(form.idagendamento)) {
            AData = form.inicio;
        }
        this.setState({
            ...this.state,
            "step": (((new Date(AData).getHours() * 60) / AStepAgendamento) * 25) + (Number.parseInt(new Date(AData).getMinutes() / AStepAgendamento) * 25),
            "time": (((new Date().getHours() * 60) / AStepAgendamento) * 25) + (Number.parseInt(new Date().getMinutes() / AStepAgendamento) * 25)
        });
    }

    componentDidUpdate(prevProps) {
        if (!_.isNull(document.getElementById("DataHoraDivHorarios")) && !_.isNull(document.getElementById("Content"))) {
            document.getElementById("DataHoraDivHorarios").style.height = (document.getElementById("Content").parentNode.offsetHeight - 200 + "px");
        }

        if (_.isEqual(this.props.form, prevProps.form) && !_.isUndefined(document.getElementsByClassName("DivHorario"))) {
            Array.from(document.getElementsByClassName("DivHorario")).forEach(item => {
                item.scrollTop = this.state.step;
            });
        }
    }

    getStepAgendamento = () => {
        const { xappRouteParams, user } = this.props;
        if (!_.isUndefined(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao)) {
            let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "INTERVALO_AGENDA" });
            if (!_.isUndefined(AConfig)) {
                return Number(AConfig.valor);
            }
        }
        return Constante.step_agendamento;
    };

    getDivHorario = (_AID) => {
        const { classes, HorarioAgendado, form } = this.props;
        return (
            <React.Fragment>
                {HorarioAgendado.filter(x => x.idpessoaformulario === _AID).map((item, x) => {
                    return (
                        <XAPPTooltip
                            key={x}
                            title={item.nome}
                            placement="top"
                        >
                            <div
                                onClick={() => {
                                    if (!_.isNull(item.idagendamento)) {
                                        // get(item.idagendamento, xappRouteParams);
                                    }
                                }}
                                className={clsx(classes.divHorarioItem, "flex flex-row", "cursor-pointer")}
                                style={{
                                    background: item.tipo === -1 ? "#666" : !_.isNull(item.idagendamento) ? "#CCC" : "rgb(255,255,153)",
                                    width: "100%",
                                    minHeight: ((item.duracao) / this.getStepAgendamento()) * 25
                                }}
                            >
                                <div
                                    className={clsx("flex w-full items-center justify-center whitespace-wrap")}
                                    style={{
                                        background: item.tipo === -1 ? "#666" : !_.isNull(item.idagendamento) ? "#CCC" : "rgb(255,255,153)",
                                        color: item.tipo === -1 ? "#FFF" : "#000",
                                        padding: "0 3px"
                                    }}
                                >
                                    <div className='flex w-full h-full'>
                                        <div className='ml-4'>
                                            <div>{item.dados.descricao}</div>
                                            {!_.isNull(item.idagendamento) && !_.isNull(form.idpessoaformulariolocal) &&
                                                item.idpessoaformulariolocal === form.idpessoaformulariolocal &&
                                                !form.responsaveis.includes(item.idpessoaformulario) &&
                                                <div>{"Horário comprometido com o local selecionado"}</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </XAPPTooltip>
                    );
                })}
            </React.Fragment>
        );
    };

    getDivDisponivel = () => {
        const { form, HorarioAgendado } = this.props;
        let ACount = -25;
        let ABackgroud = "#FFF";
        let AElement = [];
        let AHorarios = [];

        if (!_.isNull(HorarioAgendado)) {
            AHorarios = HorarioAgendado.filter(x => _.isNull(x.idpessoaformulario));
        }

        for (let x = 0; x < AHorarios.length; x++) {
            ACount += 25;
            if (x > 0 && x < AHorarios.length - 1) {
                AElement.push(
                    <React.Fragment>
                        {this.getCelTermino(AHorarios[x], ACount, (ABackgroud === "#92D050" && _.isNull(form.termino)) ? "#FFF" : ABackgroud)}
                    </React.Fragment>
                );
            }

            if (this.state.time === ACount) {
                ABackgroud = "#FFFF00";
            }
            else if (AHorarios[x].tipo === -1) {
                ABackgroud = "#666";
            }
            else if (this.isSelected(AHorarios[x])) {
                ABackgroud = "#92D050";
            }
            else if (!_.isNull(AHorarios[x].idagendamento)) {
                ABackgroud = "#CCC";
            }
            else {
                ABackgroud = "#FFF";
            }

            if (x === AHorarios.length - 1) {
                AElement.push(
                    <React.Fragment>
                        {this.getCelTermino(AHorarios[x], ACount, ABackgroud)}
                    </React.Fragment>
                );
            }
            else {
                AElement.push(
                    <React.Fragment>
                        {this.getCelInicio(AHorarios[x], ACount, ABackgroud)}
                    </React.Fragment>
                );
            }
        }
        return AElement;
    };

    getCelInicio = (_AItem, _ACount, _ABackgroud) => {
        const { classes, handleChangeHorarios, checkHorarioDisponivel } = this.props;
        let AHorario = dayjs(_AItem.inicio).format("HH:mm:ss");
        return (
            <React.Fragment>
                <XAPPTooltip
                    title={AHorario}
                    placement="top"
                >
                    <div
                        id={"Disp_Inicio_" + _ACount}
                        onClick={() => {
                            if (checkHorarioDisponivel(_AItem.inicio, AHorario, "inicio")) {
                                handleChangeHorarios(dayjs(_AItem.inicio).format("YYYY-MM-DD HH:mm:ss"), null);
                            }
                        }}
                        className={clsx(classes.divHorarioItem, "flex flex-row text-black justify-center items-center", (checkHorarioDisponivel(_AItem.inicio, AHorario, "inicio")) ? "cursor-pointer" : "cursor-not-allowed")}
                        style={{
                            background: _ABackgroud,
                            color: _ABackgroud === "#666" && "#F2F2F2",
                            width: 48,
                        }}
                    >
                        {dayjs(_AItem.inicio).format("HH:mm")}
                    </div>
                </XAPPTooltip>
            </React.Fragment>
        );
    };

    getCelTermino = (_AItem, _ACount, _ABackgroud) => {
        const { classes, handleChangeHorarios, form, checkHorarioDisponivel } = this.props;
        let AHorario = dayjs(_AItem.inicio).format("HH:mm:ss");
        return (
            <React.Fragment>
                <XAPPTooltip
                    title={AHorario}
                    placement="top"
                >
                    <div
                        id={"Disp_Termino_" + _ACount}
                        onClick={() => {
                            if (checkHorarioDisponivel(form.inicio, AHorario, "termino")) {
                                handleChangeHorarios(form.inicio, dayjs(_AItem.inicio).format("YYYY-MM-DD HH:mm:ss"));
                            }
                        }}
                        className={clsx(classes.divHorarioItem, "flex flex-row text-black justify-center items-center", (checkHorarioDisponivel(form.inicio, AHorario, "termino")) ? "cursor-pointer" : "cursor-not-allowed")}
                        style={{
                            backgroundColor: _ABackgroud,
                            color: _ABackgroud === "#666" && "#F2F2F2",
                            width: 48,
                        }}
                    >
                        {dayjs(_AItem.inicio).format("HH:mm")}
                    </div>
                </XAPPTooltip>
            </React.Fragment>
        );
    };

    isSelected = (_AItem) => {
        const { form } = this.props;
        let AFormInicio = new Date(form.inicio).getTime();
        let AFormTermino = new Date(form.termino).getTime();
        let AItemInicio = new Date(_AItem.inicio).getTime();

        if (!_.isNull(form.termino)) {
            return (
                AItemInicio >= AFormInicio && AItemInicio < AFormTermino
            );
        }
        else {
            return (
                AItemInicio === AFormInicio
            );
        }
    };

    getResponsaveis = () => {
        const { HorarioAgendado } = this.props;
        let AArray = [];
        !_.isNull(HorarioAgendado) && !_.isNull(HorarioAgendado) && HorarioAgendado.forEach(item => {
            if (((_.isNull(document.fullscreenElement) && item.selected === 1) || !_.isNull(document.fullscreenElement)) &&
                !_.isNull(item.idpessoaformulario) && AArray.filter(n => n.id === item.idpessoaformulario).length === 0) {
                AArray.push({ id: item.idpessoaformulario, nome: item.nome, selected: item.selected });
            }
        });
        return AArray;
    };

    toggleFullScreen = () => {
        let AFullScreen = document.getElementById("PaperHorario");
        let AStep = this.getStepAgendamento();
        if (_.isNull(document.fullscreenElement)) {
            AFullScreen.requestFullscreen();
            this.props.getHorarioAgendadoAll();
        } else {
            document.exitFullscreen();
        }
        window.setTimeout(() => {
            this.setState(_.set({ ...this.state }, "time", (((new Date().getHours() * 60) / AStep) * 25) + (Number.parseInt(new Date().getMinutes() / AStep) * 25)));
        }, 3000);
    };

    getHorariosSeletor = (_ATipo) => {
        const { HorarioAgendado = null, user, xappRouteParams } = this.props;
        let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "AGENDAMENTO_SIMULTANEO" });

        let AResponse = [];

        if (!_.isNull(HorarioAgendado)) {
            HorarioAgendado.forEach(item => {
                if ((_.isNull(item.idpessoaformulario) && (_ATipo === "termino" || _.isNull(item.idagendamento))) || AConfig?.valor) {
                    AResponse.push(item);
                }
            });
        }
        return AResponse;
    };

    render() {
        const { handleChangeData, handleResponsaveis, form, classes, checkHorarioDisponivel, HorarioAgendado = null, readOnly, handleChangeHorarios } = this.props;
        return (
            <React.Fragment>
                <div className="flex flex-col sm:flex-row sm:gap-6">
                    <div className="flex flex-row w-full gap-6">
                        <TextField
                            className="w-full sm:mr-8"
                            label="Data"
                            id="inicio"
                            name="inicio"
                            value={!_.isNull(form.inicio) ? form.inicio.split(" ")[0] : ""}
                            onChange={handleChangeData}
                            variant="outlined"
                            fullWidth
                            type="Date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <XAPPButton
                            className="xs:flex sm:hidden"
                            id="buttonFullScreen"
                            onClick={this.toggleFullScreen}
                            icon={_.isNull(document.fullscreenElement) ? "full_screen" : "exit_full_screen"}
                            type="icon"
                        />
                    </div>
                    <div className="flex flex-row w-full gap-6">
                        <TextField
                            className="w-full mt-16 sm:m-0"
                            label="Início"
                            id="inicio"
                            name="inicio"
                            value={!_.isNull(form.inicio) ? form.inicio.split(" ")[1] : ""}
                            onChange={ev =>
                                handleChangeHorarios(form.inicio.split(" ")[0] + " " + ev.target.value, null)}
                            variant="outlined"
                            fullWidth
                            select
                            InputLabelProps={{
                                shrink: true,
                            }}
                        >
                            {this.getHorariosSeletor("inicio").map((item, x) => (
                                <MenuItem
                                    key={x}
                                    value={dayjs(item.inicio).format("HH:mm:ss")}
                                    data={item}
                                >
                                    {dayjs(item.inicio).format("HH:mm")}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            className="w-full mt-16 sm:m-0"
                            label="Término"
                            id="termino"
                            name="termino"
                            value={!_.isNull(form.termino) ? form.termino.split(" ")[1] : ""}
                            onChange={ev => handleChangeHorarios(form.inicio, form.inicio.split(" ")[0] + " " + ev.target.value)}
                            variant="outlined"
                            fullWidth
                            disabled={_.isNull(form.inicio)}
                            select
                            InputLabelProps={{
                                shrink: true,
                            }}
                        >
                            {this.getHorariosSeletor("termino").map((item, x) => {
                                if (checkHorarioDisponivel(form.inicio, dayjs(item.inicio).format("HH:mm:ss"))) {
                                    return (
                                        <MenuItem
                                            key={x}
                                            value={dayjs(item.inicio).format("HH:mm:ss")}
                                        >
                                            {dayjs(item.inicio).format("HH:mm")}
                                        </MenuItem>
                                    );
                                }
                            })}
                        </TextField>
                    </div>
                    <XAPPButton
                        className="xs:hidden sm:flex"
                        id="buttonFullScreen"
                        onClick={this.toggleFullScreen}
                        icon={_.isNull(document.fullscreenElement) ? "full_screen" : "exit_full_screen"}
                        type="icon"
                    />
                </div>
                <div id="DataHoraDivHorarios" className="flex flex-col mt-8 overflow-x-auto overflow-y-hidden h-360">
                    {!_.isNull(HorarioAgendado) && HorarioAgendado.length > 0 ?
                        <React.Fragment>
                            <div className="flex flex-row">
                                {/* <div className={clsx(classes.header, "flex w-full items-center justify-center whitespace-no-wrap")}>
                            &nbsp;
                        </div> */}
                                <div className={clsx(classes.divNomeItem, "flex min-w-96 items-center justify-center whitespace-no-wrap min-h-32")}>
                                    <div className={clsx(classes.divNomeItem, "flex min-w-48 items-center justify-center whitespace-no-wrap")}>
                                        {"Início"}
                                    </div>
                                    <div className={clsx(classes.divNomeItem, "flex min-w-48 items-center justify-center whitespace-no-wrap")}>
                                        {"Fim"}
                                    </div>
                                </div>
                                {this.getResponsaveis().map((item) => (
                                    <div key={item.id} id={"Header_" + item.id} className={clsx(classes.divNomeItem, "flex w-full items-center justify-center whitespace-no-wrap px-4 min-h-32")}>
                                        <Radio
                                            className="p-0 mr-4 text-white"
                                            classes={{
                                                root: classes.checkboxRoot,
                                                checked: classes.checkboxChecked
                                            }}
                                            checked={item.selected === 1}
                                            name="checked"
                                            onChange={() => handleResponsaveis([{ idpessoaformulario: item.id }])}
                                            disabled={readOnly}
                                        />
                                        {item.nome.length > 12 ? (item.nome.substring(0, 11) + ".") : item.nome}
                                    </div>
                                ))}
                            </div>
                            <div id="DivHorario" className={clsx("DivHorario flex flex-row min-w-96 overflow-y-auto overflow-x-hidden", classes.divHorario)} >
                                <div className={clsx("flex flex-col items-center w-96")}>
                                    <div className="flex flex-wrap w-96 ">
                                        {this.getDivDisponivel()}
                                    </div>
                                </div>
                                {this.getResponsaveis().map((item, x) => (
                                    <div
                                        key={x}
                                        className={clsx("flex flex-col items-center min-w-96 w-full h-fit")}
                                    // style={{
                                    //     width: !_.isNull(document.getElementById("Header_" + item.id)) ? document.getElementById("Header_" + item.id).offsetWidth: 96
                                    // }}
                                    >
                                        {this.getDivHorario(item.id)}
                                    </div>
                                ))}
                            </div>
                        </React.Fragment>
                        :
                        <Loading pastDelay={true} stopByError={true} />
                    }
                </div>
            </React.Fragment >
        );
    }
}

export default withStyles(styles, { withTheme: true })(DataHora);